module.exports = __webpack_public_path__ + "img/terrasse.5379731b.jpg";